module.exports = __webpack_public_path__ + "img/Frame.726dbe66.png";